var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('Filters',{attrs:{"projects":_vm.userProjects},on:{"filter":_vm.applyFilters}}),_c('ProjectList',{attrs:{"projects":_vm.filteredUserProjects}}),_c('WorkbookEntryModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }